import React from 'react';

import styles from '../css/Layout.module.css';
import Header from './header/Header';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  return (
    <div className={styles.layout}>
      <Header />
      <Sidebar />
      <main className={styles.mainContent}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
